import { Link } from 'react-router-dom';

interface GarmentTagProps {
  children: React.ReactNode;
  onClick?: () => void;
  to?: string;
  href?: string;
  target?: string;
  rel?: string;
  active?: boolean;
  holeColor?: string;
  className?: string;
}

export function GarmentTag({
  children,
  onClick,
  to,
  href,
  target,
  rel,
  active = false,
  holeColor = 'var(--color-champagne-light)',
  className = '',
}: GarmentTagProps) {
  const isInteractive = Boolean(onClick || to || href);
  const stateClasses = active
    ? 'bg-chocolate-dark border-chocolate-dark text-white shadow-sm'
    : isInteractive
      ? 'bg-white border-champagne-dark text-text-medium hover:border-chocolate-dark hover:text-chocolate-dark'
      : 'bg-champagne-light border-champagne text-text-medium';
  const interactiveClasses = isInteractive
    ? 'cursor-pointer min-h-[44px] focus:outline-none focus-visible:ring-2 focus-visible:ring-chocolate-dark focus-visible:ring-offset-2'
    : 'cursor-default';

  const baseClasses = [
    'relative inline-flex items-center gap-2 pl-3 sm:pl-6 pr-4 py-2 rounded-md border text-sm font-medium whitespace-nowrap transition-colors duration-150',
    stateClasses,
    interactiveClasses,
    className,
  ].join(' ');

  const inner = (
    <>
      <span
        aria-hidden="true"
        className="hidden sm:block absolute left-2 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full border border-current opacity-40"
        style={{ backgroundColor: holeColor }}
      />
      {children}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={baseClasses}>
        {inner}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} target={target} rel={rel} className={baseClasses}>
        {inner}
      </a>
    );
  }

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={baseClasses}>
        {inner}
      </button>
    );
  }

  return <div className={baseClasses}>{inner}</div>;
}
